import { render, staticRenderFns } from "./location-section-card.vue?vue&type=template&id=2181b3fa&scoped=true&"
import script from "./location-section-card.vue?vue&type=script&lang=js&"
export * from "./location-section-card.vue?vue&type=script&lang=js&"
import style0 from "./location-section-card.vue?vue&type=style&index=0&id=2181b3fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2181b3fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2181b3fa')) {
      api.createRecord('2181b3fa', component.options)
    } else {
      api.reload('2181b3fa', component.options)
    }
    module.hot.accept("./location-section-card.vue?vue&type=template&id=2181b3fa&scoped=true&", function () {
      api.rerender('2181b3fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/elements/location-section-card.vue"
export default component.exports